import Text from '../Text';
import PieValueFormatter from './PieValueFormatter';

const RADIAN = Math.PI / 180;

const PieLabel = ({
  percent,
  cx,
  cy,
  midAngle,
  outerRadius,
  fill,
  offset,
  labelType,
  value,
  formatter,
}) => {
  const radius = outerRadius + offset;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <Text
      x={x}
      y={y}
      fill={fill}
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline={'central'}
    >
      <PieValueFormatter
        value={value}
        formatter={formatter}
        percent={percent}
        labelType={labelType}
        shot={true}
      />
    </Text>
  );
};

export default PieLabel;
